import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'sd-distribution-guide',
  templateUrl: './distribution-guide.component.html',
  styleUrls: ['./distribution-guide.component.scss']
})
export class DistributionGuideComponent implements OnInit {
  tab: string = "release_details"

  constructor(private route: ActivatedRoute, private router: Router, public global: GlobalService) {
    this.route.queryParams.subscribe((res) => {
      this.tab = res.tab ? res.tab : "release_details";
    })
  }


  ngOnInit(): void {
  }

  navigateTo(data) {
    this.tab = data;
    this.router.navigate([], {
      queryParams: {
        tab: data
      },
      queryParamsHandling: 'merge',

    });
  }
}
